<template>
  <svg
    aria-hidden="true"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    ...attributes
  >
    <path
      stroke="currentColor"
      stroke-linecap="round"
      stroke-linejoin="round"
      stroke-width="1.5"
      d="M19.25 5.75H4.75v4.5m14.5-4.5v4.5h-3m3-4.5-2.5 4.5m-12 0h3m-3 0 2.5-4.5m.5 4.5v8m0-8h8.5m-8.5 0 2.5-4.5m6 4.5v8m-3-12.5-2.5 4.5m5.5-4.5-2.5 4.5"
    ></path>
  </svg>
</template>
